export default "__VITE_ASSET__Bob7chc2__"